import { render, staticRenderFns } from "./UploadHistoryTable.vue?vue&type=template&id=ef8b067e"
import script from "./UploadHistoryTable.vue?vue&type=script&lang=js"
export * from "./UploadHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./UploadHistoryTable.vue?vue&type=style&index=0&id=ef8b067e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports